import { posToDOMRect } from "@tiptap/core";
import { InstagramSmall, TikTokSmall, XCorpSmall } from "@wix/wix-ui-icons-common";
import { quickActionsModalSections, RicosPluginToolbarNames } from "./../ricos-types/index.js";
import { changeSelectionToEndOfTextBlock } from "./../wix-rich-content-common/index.js";
import { socialModals } from "./consts.js";
import { DEFAULTS } from "./defaults.js";
import { embedConverter } from "./embed-converter.js";
import { getAddButtons } from "./getAddButtons.js";
import { getToolbarButtons } from "./getToolbarButtons.js";
import { linkPreviewConverter } from "./link-preview-converter.js";
import { InsertModal } from "./modals/InsertModal.js";
import { SettingsModal } from "./modals/SettingsModal.js";
import { tiptapExtensions } from "./tiptap/tiptap.js";
import { LINK_PREVIEW_TYPE } from "./types.js";
const pluginLinkPreview = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: LINK_PREVIEW_TYPE,
    pmMarkConverters: [],
    pmNodeConverters: [linkPreviewConverter, embedConverter],
    tiptapExtensions,
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    toolbar: {
      names: [RicosPluginToolbarNames.LINK_PREVIEW, RicosPluginToolbarNames.EMBED],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    getQuickActions: ({ config: config2, pluginServices }) => {
      const { fetchData } = config2 || {};
      const isMobile = pluginServices.context.isMobile;
      const toggleInsertModal = ({
        id,
        socialType,
        modalService,
        editor
      }) => {
        modalService.togglePluginPanel({
          id,
          Component: InsertModal,
          componentProps: {
            fetchData,
            socialType
          },
          isMobile,
          positioning: {
            referenceElement: {
              getBoundingClientRect: () => posToDOMRect(
                editor.view,
                editor.view.state.selection.from,
                editor.view.state.selection.to
              )
            },
            placement: "bottom-end"
          },
          mobileLayout: "drawer"
        });
      };
      return [
        {
          id: "instagramPost",
          title: "QuickActionsPlugin_ActionTitle_InstagramPost",
          icon: InstagramSmall,
          section: quickActionsModalSections.Embed,
          tags: ["post", "photo", "video", "social media", "story", "ig post"],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            toggleInsertModal({
              id: socialModals.instagram,
              socialType: "Instagram",
              modalService,
              editor
            });
          }
        },
        {
          id: "tiktokVideo",
          title: "QuickActionsPlugin_ActionTitle_TikTokVideo",
          icon: TikTokSmall,
          section: quickActionsModalSections.Embed,
          tags: ["video", "social media", "content", "short video", "clip"],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            toggleInsertModal({
              id: socialModals.tiktok,
              socialType: "TikTok",
              modalService,
              editor
            });
          }
        },
        {
          id: "xPost",
          title: "QuickActionsPlugin_ActionTitle_XPost",
          icon: XCorpSmall,
          section: quickActionsModalSections.Embed,
          tags: ["social media", "tweet", "update", "content", "post", "link", "article", "blog"],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            toggleInsertModal({
              id: socialModals.twitter,
              socialType: "Twitter",
              modalService,
              editor
            });
          }
        }
      ];
    },
    __exports: {
      InsertModal,
      SettingsModal
    }
  };
};
export {
  pluginLinkPreview
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject.js";
injectCss();
